import type { ResourcesConfig } from 'aws-amplify'
import { signInWithRedirect } from 'aws-amplify/auth'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { CookieStorage } from 'aws-amplify/utils'

// 本番デプロイ時は portal 配下の Cookie でトークンを共有するため、
// portal と同じ client_id を使う。localhost 開発時はこのアプリ独自の client_id で
// 既存の Google サインインを維持する (Cookie 共有はポート分離のため使えない)。
const sharedClientId = import.meta.env.VITE_COGNITO_SHARED_CLIENT_ID
const isSharedSession = Boolean(
  sharedClientId && import.meta.env.VITE_COOKIE_DOMAIN
)

export const isLocalhostSignIn = !isSharedSession

export const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId:
        import.meta.env.VITE_COGNITO_USER_POOL_ID || 'ap-northeast-1_XXXXXXXXX',
      userPoolClientId:
        sharedClientId ||
        import.meta.env.VITE_COGNITO_CLIENT_ID ||
        'xxxxxxxxxxxxxxxxxxxxxxxxxx',
      loginWith: {
        oauth: {
          domain:
            import.meta.env.VITE_COGNITO_DOMAIN ||
            'hakuou-dev.auth.ap-northeast-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [`${window.location.origin}/callback`],
          redirectSignOut: [window.location.origin],
          responseType: 'code',
          providers: ['Google'],
        },
      },
    },
  },
}

// 本番では .app.hakuou.co.jp の Cookie に Cognito トークンを保存して
// portal とサブアプリで共有する。
// NOTE: Amplify.configure() の "後" に呼ぶ必要があるため main.tsx 側から明示的に実行する。
export function configureCookieStorage() {
  const cookieDomain = import.meta.env.VITE_COOKIE_DOMAIN
  if (!cookieDomain) return
  cognitoUserPoolsTokenProvider.setKeyValueStorage(
    new CookieStorage({
      domain: cookieDomain,
      secure: true,
      path: '/',
      sameSite: 'lax',
    })
  )
}

// 未認証・トークン失効時のサインイン誘導。
// 本番は portal に集約する: 共有クライアントの CallbackURL は portal のみ許可されており、
// サブアプリから Cognito Hosted UI を直接叩くと redirect_mismatch になるため。
// localhost はサブアプリ単独で Google サインインする。
export async function redirectToSignIn() {
  if (isLocalhostSignIn) {
    await signInWithRedirect()
    return
  }
  const portalUrl = import.meta.env.VITE_PORTAL_URL
  if (portalUrl) {
    const returnTo = encodeURIComponent(window.location.href)
    window.location.href = `${portalUrl}/?return_to=${returnTo}`
  } else {
    await signInWithRedirect()
  }
}

export const apiConfig = {
  baseUrl:
    import.meta.env.VITE_API_BASE_URL ||
    'https://xxxxxxxxxx.execute-api.ap-northeast-1.amazonaws.com/dev',
}
